import API from "serviceshift-ui/api-client";

export default {
  completeWorkItem(_, id) {
    return API.makeRequest(`/v2/workflow_items/${id}/complete`, {
      method: "PUT",
    });
  },
  resetWorkItem(_, id) {
    return API.makeRequest(`/v2/workflow_items/${id}/reset`, {
      method: "PUT",
    });
  },
};
